import * as tslib_1 from "tslib";
import { PagingSerializer } from 'src/app/models/serializers/paging-serializer';
import { RequestSettings } from 'src/app/models/requests/request-settings';
export class BaseService {
    constructor(rq, serviceEndpoints, serializer) {
        this.rq = rq;
        this.serviceEndpoints = serviceEndpoints;
        this.serializer = serializer;
        this.endpoints = serviceEndpoints;
        this.request = rq;
        this.dataSerializer = serializer;
    }
    get(id) {
        return this.request.get(this.endpoints.get + '/' + id);
    }
    getAll(page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield this.request.get(this.endpoints.getAll + '?page=' + page, new RequestSettings({
                serializer: PagingSerializer.serialize
            }));
            if (this.dataSerializer) {
                res.data = this.dataSerializer(res.data);
            }
            return res;
        });
    }
    create(model) {
        return this.request.post(this.endpoints.create, model);
    }
    update(model) {
        return this.request.patch(this.endpoints.update, model);
    }
    delete(id) {
        return this.request.delete(this.endpoints.delete + '/' + id);
    }
}
